<template>
  <v-container style="padding: 0">
    <v-form ref="labelsForm" v-model="isValidComputed" class="pl-6 pb-2">
      <style-dialog-style-rows
        :has-copy-button="symbolizationType !== 'single'"
        :items="labelsStyleInputs"
        v-model="computedLabelsStyle"
        style-type="label"
      >
        <template #attributes="scope">
          <data-input v-bind="scope" v-model="computedLabelsStyle['attributes']">
            <template #selection="{ item, index }">
              <v-tooltip v-if="index === 0" bottom color="font">
                <template #activator="{ on }">
                  <v-chip v-on="on" x-small>
                    <div class="text-truncate">{{ item.text }}</div>
                  </v-chip>
                </template>
                {{ item.text }}
              </v-tooltip>
              <div v-if="index === 1" class="grey--text caption" style="white-space: nowrap !important;">
                {{ otherAttributesText }}
              </div>
            </template>
          </data-input>
        </template>
        <template #zoom="input">
          <style-dialog-zoom-input
            :inputBind="input"
            :minzoom.sync="computedLabelsStyle['minzoom']"
            :maxzoom.sync="computedLabelsStyle['maxzoom']"
          />
        </template>
      </style-dialog-style-rows>
    </v-form>
    <style-dialog-labels-preview :labels-style="computedLabelsStyle" :is-style-valid="isValidComputed" />
  </v-container>
</template>
<script>
import style from '@/mixins/style';
import DataInput from '@/components/DataInput';
import StyleDialogStyleRows from '@/components/StyleDialogStyleRows';
import StyleDialogLabelsPreview from '@/components/StyleDialogLabelsPreview';
import StyleDialogZoomInput from '@/components/StyleDialogZoomInput';

export default {
  name: 'StyleDialogLabelsTab',
  mixins: [style],
  components: {
    DataInput,
    StyleDialogStyleRows,
    StyleDialogLabelsPreview,
    StyleDialogZoomInput,
  },
  props: {
    attributes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isValid: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    labelsStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    symbolizationType: {
      type: String,
      default: 'point',
    },
    geometryType: {
      type: String,
      required: true,
    },
  },
  computed: {
    computedLabelsStyle: {
      get() {
        return this.labelsStyle;
      },
      set(nV) {
        this.$emit('update:labelsStyle', nV);
      },
    },
    labelsStyleInputs() {
      if (['linestring', 'multilinestring'].includes(this.geometryType)) {
        return this.labelsItems.filter(item => item.name !== 'offset-x');
      }
      return this.labelsItems;
    },
    isValidComputed: {
      get() {
        return this.isValid;
      },
      set(nV) {
        this.$emit('update:isValid', nV);
      },
    },
    otherAttributesText() {
      const otherAttributesLength = this.computedLabelsStyle.attributes.length - 1;
      return `(+${this.$i18n.tc('admin.other', otherAttributesLength)})`;
    },
  },
  watch: {
    'computedLabelsStyle.attributes': {
      handler(nV, oV) {
        const items = this.labelsItems.find(labelItem => labelItem.name === 'attributes')?.items || [];
        const fixedValue = nV.filter(value => items.find(item => item.valueLabel === value));
        if (JSON.stringify(nV) !== JSON.stringify(fixedValue))
          this.$set(this.computedLabelsStyle, 'attributes', fixedValue);
        if (!oV || (oV.length === 0 && nV.length > 0)) {
          const params = {
            'font-size': 12,
            'font-weight': 'normal',
            minzoom: 12,
            maxzoom: null,
            'offset-x': 0,
            'offset-y': 0,
            'stroke-width': 3,
          };
          for (const param of Object.keys(params)) {
            if (!this.computedLabelsStyle[param]) {
              this.$set(this.computedLabelsStyle, param, params[param]);
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-input--checkbox {
    margin-top: 0 !important;
    .v-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 15px;
      color: #202124;
    }
  }
}
</style>
